import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import {
  useEnterpriseLearningPathName,
  useEnterpriseLearningPathPageData,
} from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import { useSkillTagsData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathSkillsContext';
import Renderer from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRenderer';
import EventingDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EventingDataProvider';
import {
  LEARNING_PATH_NAV_ITEMS,
  getLearningPathPageNavigationLinks,
} from 'bundles/enterprise-learning-path-description-page/utils/getPageNavigationLinks';
import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';
import PageInfoProvider from 'bundles/unified-description-page-common/providers/PageInfoProvider';
import PageNavigationProvider from 'bundles/unified-description-page-common/providers/PageNavigationProvider';
import { ModuleNames } from 'bundles/unified-description-page-common/types/moduleConfig';

const EnterpriseLearningPathPageRootContent = () => {
  const pageData = useEnterpriseLearningPathPageData();
  const productTitle = useEnterpriseLearningPathName();
  const skillTagsData = useSkillTagsData();
  const { programSlug, orgSlug } = useParams();
  const isOrgScopedHome = useIsOrgScopedHome();

  if (!pageData || !productTitle || !skillTagsData) {
    return null;
  }

  const pageConfig = {
    modules: [{ name: ModuleNames.Breadcrumbs }, { name: ModuleNames.ProductOverview }, { name: ModuleNames.Syllabus }],
  };

  const navigationLinks = getLearningPathPageNavigationLinks({ pageData, pageConfig });

  return (
    <PageInfoProvider {...(isOrgScopedHome ? { orgSlug } : { programSlug })} navigationIdMap={LEARNING_PATH_NAV_ITEMS}>
      <SimpleCourseraMetatags disableCrawlerIndexing title={productTitle} />
      <EventingDataProvider productId={pageData.enterpriseBadge.id} productType="learning_path">
        <PageNavigationProvider navigationLinks={navigationLinks}>
          {/* <StickyPanelProvider> */}
          {/* <FixedPageNavigation productTitle={productTitle} navigationLinks={navigationLinks} /> */}
          <Renderer
            productTitle={productTitle}
            pageData={pageData}
            pageConfig={pageConfig}
            skillTagsData={skillTagsData}
          />
          {/* </StickyPanelProvider> */}
        </PageNavigationProvider>
      </EventingDataProvider>
    </PageInfoProvider>
  );
};

export default EnterpriseLearningPathPageRootContent;
